@if (job) {
  <p-card [styleClass]="'long-running-job-card status-' + job.status">
    @switch (job.status) {
      @case (LongRunningJobStatus.WAITING) {
        <p-progressSpinner></p-progressSpinner>
        <span class="ml-2" style="vertical-align: middle">
          {{job.translatedTypeName}}
        </span>
      }
      @case (LongRunningJobStatus.RUNNING) {
        <p-progressSpinner></p-progressSpinner>
        @if (!!job.progress && job.progress !== 100) {
          <span>
            {{ job.progress / 100 | percent }}
          </span>
        }
        <span class="ml-2" style="vertical-align: middle">
          {{job.translatedTypeName}}
        </span>
      }
      @case (LongRunningJobStatus.DONE) {
        <i class="fa fa-solid fa-check vertical-middle" style="font-size: 2rem"></i>
        <span class="ml-2" i18n="@@long_running_jobs-task_succeeded">The task has succeeded.</span>
      }
      @case (LongRunningJobStatus.ERROR) {
        <i class="fa fa-solid fa-triangle-exclamation vertical-middle" style="font-size: 2rem"></i>
        <span class="ml-2" i18n="@@long_running_jobs-task_failed">The task has failed.</span>
      }
    }

    @if (job.message?.message && job.message?.message !== 'SUCCESS') {
      <span class="ml-2"><pre>{{job.message?.message}}</pre></span>
    }
    @if (job.message?.detail) {
      <span class="ml-2">{{ job.message?.detail }}</span>
    }

    <div class="mt-3">
      @if (job.status === LongRunningJobStatus.DONE && job.type.indexOf('export') > -1) {
        <button pButton i18n-label="@@long_running_jobs-successful_export_button"
          label="Download the exported file."
          class="p-button-text" (click)="downloadAttach(job.message?.attachUuid)"></button>
      }
      @if (job.status === LongRunningJobStatus.ERROR && job.type.indexOf('import') > -1 && job.message?.attachUuid) {
        <button pButton
          i18n-label="@@long_running_jobs-failed_import_button"
          label="Download the error report to identify the errors present in your import file."
          class="p-button-text" (click)="downloadAttach(job.message?.attachUuid)"></button>
      }
      <button pButton pRipple type="button" icon="fa fa-solid fa-xmark" (click)="onLRJCloseClick(job)"
        class="p-button-text close-button"></button>
    </div>
  </p-card>
}
